import { useUserStore } from "@/stores/userStore";
import useGetAccessToken from "@/use/useGetAccessToken";
import { handlePasswordExpiredInfo } from "@/utils/handlePasswordExpiredInfo";

import dayjs from "dayjs";

export const useCheckPasswordExpired = () => {
  const userStore = useUserStore();

  const { getCheckPasswordCalledDate, getValidEndDate } =
    handlePasswordExpiredInfo();

  const shouldCheckPasswordExpired = (expiredAlramIntervalDay: number) => {
    const isLoggedIn = !!useGetAccessToken();

    // 로그아웃 상태인가?
    if (!isLoggedIn) return false;

    const validEndDate = getValidEndDate();
    const now = dayjs();

    // 비밀번호 만료기한이 expiredAlarmInvervalDay보다 많이 남았는가?
    if (dayjs(validEndDate).diff(now, "day") > expiredAlramIntervalDay)
      return false;

    const APICalledDate = getCheckPasswordCalledDate();

    // 오늘 API가 호출되었는가?
    if (dayjs(APICalledDate).isSame(now, "day")) return false;

    return true;
  };

  const checkPasswordExpired = async (expiredAlramIntervalDay: number) => {
    if (!shouldCheckPasswordExpired(expiredAlramIntervalDay)) return;

    const result = await userStore.checkIfPasswordNeedsChange();
    return result;
  };

  return { checkPasswordExpired };
};
